import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * The head of a settings page (2026-10-22): what this page is for, in one
 * or two sentences, and a few facts about it as chips. Replaces the grey
 * "Qanday ishlaydi" notes the pages opened with.
 *
 * `readOnly` adds a chip saying so, because a read-only grant sees the same
 * page with the edit buttons gone and might otherwise look for them.
 */
const PageIntro = ({ icon, title, children, chips = [], readOnly = false }) => (
  <section className="ms-intro">
    <span className="ms-intro-icon">
      <Icon icon={icon} />
    </span>
    <div className="ms-intro-body">
      <h1>{title}</h1>
      <p>{children}</p>
      {(chips.length > 0 || readOnly) && (
        <div className="ms-intro-chips">
          {chips.map((c) => (
            <span key={c.label} className={`ms-intro-chip${c.tone ? ` is-${c.tone}` : ""}`}>
              {c.icon && <Icon icon={c.icon} />}
              {c.label}
            </span>
          ))}
          {readOnly && (
            <span className="ms-intro-chip">
              <Icon icon="tabler:eye" />
              Siz faqat koʻrasiz
            </span>
          )}
        </div>
      )}
    </div>
  </section>
);

export default PageIntro;
